import template from './ticketContactEdit.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    contact: '<',
    ticketContacts: '<',
    ticketContactLabels: '<',
    countries: '<',
    options: '<',
    isDisabled: '<',
    onDeleted: '&',
    onFinished: '&'
  },
  controller: class controller {
    constructor($rootScope, $mdMedia, helperService, searchService, contactService, uiService) {
      'ngInject';

      const ctrl = this;
      ctrl.$mdMedia = $mdMedia;
      ctrl.organizationCountry = null;
      ctrl.currentOrganization = null;
      ctrl.emailValidationMessage = '';
      ctrl.searchText = '';

      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry();
        ctrl.currentOrganization = $rootScope.CurrentOrganization;
        ctrl.contact = ctrl.contact || {};
        ctrl.ticketContacts = ctrl.ticketContacts || [];
        ctrl.ticketContactLabels = ctrl.ticketContactLabels || [];
        ctrl.countries = ctrl.countries || [];
        ctrl.options = ctrl.options || {};
        ctrl.isDisabled = ctrl.isDisabled || false;
      };

      ctrl.contactChange = _.debounce((contact) => {
        if (ctrl.contact.name === null) {
          ctrl.contact.name = ctrl.searchText;
        }
        const idx = _.indexOf(ctrl.ticketContacts || [], contact);
        if (idx > -1) {
          ctrl.ticketContacts[idx] = contact;
        }
        ctrl.onFinished();
      }, 2000);

      ctrl.contactDelete = ($event, contactToDelete) => {
        ctrl.onDeleted({ event: $event, contact: contactToDelete });
      };

      ctrl.selectedItemChange = (selectedContact) => {
        if (selectedContact?.id) {
          contactService.readContact({ id: selectedContact.id }).then((data) => {
            const contact = data;
            if (contact) {
              const contactExist = _.find(ctrl.ticketContacts, { id: contact.id });
              if (!contactExist) {
                ctrl.contact.id = contact.id;
                ctrl.contact.isCompany = contact?.isCompany || false;
                ctrl.contact.name = contact?.isCompany
                  ? contact?.company?.information?.name || 'N/A'
                  : contact?.person?.information?.firstName || 'N/A';
                ctrl.contact.familyName = contact.person?.information?.familyName || '';
                ctrl.contact.phoneCode = contact?.isCompany
                  ? contact?.company?.contact?.phoneCode || ''
                  : contact?.person?.contact?.primaryCode || '';
                ctrl.contact.phone = contact?.isCompany
                  ? contact?.company?.contact?.phone || ''
                  : contact?.person?.contact?.primary || '';
                ctrl.contact.email = contact?.isCompany
                  ? contact?.company?.contact?.email || ''
                  : contact?.person?.contact?.email || '';
                ctrl.contactChange(ctrl.contact);
              } else {
                ctrl.contact.name = '';
                uiService.toast({
                  text: { p1: 'WARNING', p2: 'Contact cannot be', p3: 'added twice' },
                  warn: true
                });
              }
            }
          });
        }
      };

      ctrl.searchContact = (query, isContactCompany) =>
        searchService.getContacts({ query, isCompany: isContactCompany });

      ctrl.getContactType = (idContactType) =>
        _.find(ctrl.ticketContactLabels || [], (l) => l?.id === idContactType);

      ctrl.getIndex = (contact) => _.indexOf(ctrl.ticketContacts || [], contact);

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
